<template lang="pug">
  .wrapper
    table-collapse(
      :class="wrapClass"
      v-for="{title, tip, data, property, tableLayout, type, sectionDisabledMsg, extraField} in sections"
      v-if="!loading"
      :key="property"
      :type="type"
      :table-data="data"
      :table-layout="tableLayout"
      :title="title"
      :extraField="extraField"
      :show-content="getPropValue(property)"
      :tip="tip"
      :sectionDisabledMsg="sectionDisabledMsg"
      @toggle="toggleDisplaySection({property})"
    )
    div(:class="wrapClass" v-else)
      loading
</template>
<script>
import { mapMutations, mapState, } from 'vuex'
import { TOGGLE_DISPLAY_SECTION, } from '@/store/modules/record/mutations-types'
import TableCollapse from '@/components/record-details/table-components/TableCollapse'
import Loading from '@/components/lei-components/Loading'

export default {
  components: {
    Loading,
    TableCollapse,
  },
  props: {
    sections: {
      type: Array,
      required: true,
    },
    forModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wrapClass () {
      return this.forModal ? 'modal-container' : 'container mb-10'
    },
    ...mapState('credential', [ 'loading', ]),
  },
  methods: {
    getPropValue (prop) {
      return prop ? this.$store.state.record[prop] : prop
    },
    ...mapMutations('record', {
      toggleDisplaySection: TOGGLE_DISPLAY_SECTION,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../../assets/styles/variables.styl"
</style>



// WEBPACK FOOTER //
// src/components/record-details/credentials/CollapsedCredentialSections.vue